import { Head, usePage } from "@inertiajs/react"

import { PlaceholderPattern } from "@/components/placeholder-pattern"
import { Prompt } from "@/components/prompt"
import { PromptTabs } from "@/components/prompt-tabs"
import AppLayout from "@/layouts/app-layout"
import { draftsPath } from "@/routes"

export default function NewDraft() {
  const { follow_up, placeholder } = usePage<{
    follow_up: string
    placeholder: string
  }>().props

  return (
    <AppLayout>
      <Head title="New Draft" />

      <PromptTabs active="idea" />

      <div className="bg-card relative flex h-full min-h-[100vh] flex-1 flex-col gap-5 overflow-hidden rounded-xl px-20 py-12 pb-40 md:min-h-min">
        <PlaceholderPattern className="flex size-full flex-1 grow rounded-xl stroke-neutral-900/20 dark:stroke-neutral-100/20" />
      </div>

      <Prompt
        prompt={follow_up}
        placeholder={placeholder}
        action={draftsPath()}
      />
    </AppLayout>
  )
}
